import React, { useState, useEffect, useRef } from "react";
import { handleZoom } from "../narrativeUtils/canvas"
import Config from "../../Config.json";
import MenuList from '../module.menulist';
import Modal from '../module.modal';
import Icons from '../module.icons';
import Cookies from 'js-cookie';
import gsap from "gsap";
import axios from "axios";
import classNames from "classnames";
import {getFileType} from "../../utils/helpers";
import { apiCall } from "../narrativeUtils/fetch";
import {animDropDown, handleInputFocus} from "../../utils/form.tools";
// import { handleLayerAddedMain } from "../narrativeUtils/onLayerAdded";
import {ReactComponent as AutoRenew} from "../../static/icons/autorenew.svg"
import {ReactComponent as OpenLink} from "../../static/svg/openLink-w.svg";
import {ReactComponent as ChevronDown} from "../../static/icons/chevron_down.svg" 
import {ReactComponent as AllPhotos} from "../../static/icons/photo_library.svg";
import {ReactComponent as UploadIcon} from "../../static/icons/upload.svg";

function NarrativeTools(props) {

  const escListener = useRef();
  const clickListener = useRef();
  const textShield = useRef();
  const layerFormat = React.useRef();
  const autoZoomed = React.useRef();
  const zoomCount = React.useRef(0);
  const lastActiveId = React.useRef();
  const [acceptValues, setAcceptValues] = useState('init');
  const [activeBtn, setActiveBtn] = useState();
  const [narrativeUpdating, setNarrativeUpdating] = useState(false);
  const [dropDown, setDropDown] = useState();
  const [zoomState, setZoomState] = useState(parseInt(props.zoomRatio*100))
  const [showTools, setShowTools] = useState(false);


  useEffect(() => {
    
    if ((props.activeSectionObj && autoZoomed.current === false) || (props.activeSectionObj && props.activeSectionObj.id !== lastActiveId.current)) {
      console.log('props.activeSectionObj firing', props.activeSectionObj)
     setTimeout(() => {
        autoZoomed.current = true;
        lastActiveId.current = props.activeSectionObj.id
        onZoomChoice('fit')
        // setAutoZoomed(true);
      }, 700);
    } else {
      if (autoZoomed.current === true) {
        autoZoomed.current = false;
        zoomCount.current = 0;
      }
      
     
    }

    return () => {
      autoZoomed.current = false;
      zoomCount.current = 0;
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activeSectionObj])


  useEffect(() => {
    function handleClickOutside(e) {
      let uploadModal = document.getElementById('uploadModal');
      let toolsModal = document.getElementById('toolsModal');
      if (uploadModal && uploadModal.classList.contains('on') && !uploadModal.parentElement.contains(e.target)) {
        uploadModal.classList.remove('on');
      }
      if (toolsModal && !toolsModal.parentElement.contains(e.target)) {
        setShowTools(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [])

  useEffect(() => {
    if (dropDown) {
      animDropDown(true, '0', dropDown);
    } else {
      animDropDown(false, '0', dropDown)
    }
  }, [dropDown])

  useEffect(() => {
    if (props.zoomNumber && props.activeDisplay) {
      try {
        setTimeout(() => {
          let canvasForm = document.getElementById('canvasForm');
          if (canvasForm){
          let zoomPerc = parseInt((canvasForm.getBoundingClientRect().width + 50)/props.activeDisplay.width_px * 100);
          setZoomState(zoomPerc)
          }
       
        }, 300);
        
      } catch (error) {
        
      }
   
     
    }
  }, [props.zoomNumber, props.activeDisplay])

  useEffect(() => {
    props.isDrawing && setActiveBtn(null)
  }, [props.isDrawing])

  function onDropDown(e, field) {
    if (field === dropDown) {
      setDropDown(null); 
    } else {
      setDropDown(field)
    }
  }



  function handleLayerAdded(
    format,
    subformat,
    y_pos,
    x_pos
  ) {
    let files = document.getElementById('fileUpload').files;
     autoZoomed.current = false;
    props.handleLayerAdded(
      format,
      subformat,
      y_pos,
      x_pos,
      layerFormat,
      files
    )
  }

  function handleMediaChoice(isNormal) {
        setAcceptValues(null);
        let fileInput = document.getElementById('fileUpload');
        fileInput.files = null;
        fileInput.value = "";

        function handleMediaChoiceValue(isNormal, callback) {
          if (isNormal) {
            layerFormat.current = "normal";
            setAcceptValues("image/png, image/jpeg, image/webp, video/mp4, video/webm, video/quicktime, image/svg+xml");
          } else {
            layerFormat.current = "statePNGButton";
            setAcceptValues("image/png, image/jpeg, image/webp, image/svg+xml");
          }
          callback();
        }
  
        function setupFileUpload() {
          var fileElem = document.getElementById('fileUpload');
  
          setTimeout(() => {
            fileElem.click();
          }, 150);
        }
  
        handleMediaChoiceValue(isNormal, setupFileUpload);
  
  }


    function handleShowFullCanvas(e) {
        if (props.showFullCanvas) {
            props.setShowFullCanvas(false);
        } else {
            props.setShowFullCanvas(true);
        }
        
      }
  
    function onSelectDisplay(obj) {
      props.setActiveDisplay(obj)
      props.setAspectRatio(Number(obj.height));
      setDropDown(null);
      props.onMouseLeave() 
      console.log('onSelectDisplay', Number(obj.height_px))
  
    }

    function handleTextClick(e) {
      function calcLeft(e){
        let r = (e.clientX - e.target.getBoundingClientRect().x)/e.target.getBoundingClientRect().width;
        return parseInt(r * props.activeDisplay.width_px)
      }
  
      function calcTop(e){
        let r = (e.clientY - e.target.getBoundingClientRect().y)/e.target.getBoundingClientRect().height;
        return parseInt(r * props.activeDisplay.height_px )
      }
      console.log("handleTextClick", e)
     
      handleLayerAdded("text", null, calcTop(e), calcLeft(e))
      setActiveBtn(null);
      textShield.current.removeEventListener('click', clickListener.current);
      window.removeEventListener('keydown', escListener.current)
      textShield.current.remove();
    }

    function handleEscClick(e) {

      if(e.key === "Escape") {
        setActiveBtn(null);
        window.removeEventListener('keyPress', escListener.current);
        textShield.current.removeEventListener('click', clickListener.current);
        textShield.current.remove();
      }
    }

     function addPopup() {
      closeUploadModal();
      closeShapesModal();
      props.setIsDrawing(false)
      if (activeBtn === 'popup') {
        setActiveBtn(null);
        textShield.current.removeEventListener('click', clickListener.current);
        window.removeEventListener('keydown', escListener.current)
        textShield.current.remove();
      } else {
        setActiveBtn('popup');
        let target = document.getElementById('canvasForm');
        textShield.current = document.createElement('span');
        textShield.current.classList.add('textShield');
        target.prepend(textShield.current);
        clickListener.current = textShield.current.addEventListener('click', function(e){onAddPopUp(e)})
        escListener.current = window.addEventListener('keydown', function(e){handleEscClick(e)})
      }
    }
  
    function onAddPopUp(e){
 
    
      function calcLeft(e){
        let r = (e.clientX - e.target.getBoundingClientRect().x)/e.target.getBoundingClientRect().width;
        return parseInt(r * props.activeDisplay.width_px)
      }
  
      function calcTop(e){
        let r = (e.clientY - e.target.getBoundingClientRect().y)/e.target.getBoundingClientRect().height;
        return parseInt(r * props.activeDisplay.height_px)
      }
      console.log("onAddPopUp", calcTop(e), calcLeft(e))

      handleLayerAdded("popup", null, calcTop(e), calcLeft(e))
    setActiveBtn(null);
    textShield.current && textShield.current.removeEventListener('click', clickListener.current);
    window.removeEventListener('keydown', escListener.current)
    textShield.current && textShield.current.remove();  
      
    }

    function addText() {
      closeUploadModal();
      closeShapesModal();
      props.setIsDrawing(false)
      if (activeBtn === 'text') {
        setActiveBtn(null);
        textShield.current.removeEventListener('click', clickListener.current);
        window.removeEventListener('keydown', escListener.current)
        textShield.current.remove();
      } else {
        setActiveBtn('text');
        let target = document.getElementById('canvasForm');
        textShield.current = document.createElement('span');
        textShield.current.classList.add('textShield');
        target.prepend(textShield.current);



        clickListener.current = textShield.current.addEventListener('click', function(e){handleTextClick(e)})
        escListener.current = window.addEventListener('keydown', function(e){handleEscClick(e)})
      }
    }

    function updateNarrativePDF() {
      if (module) {
        // setShowLoader(true);
        let completed;
        let startTimeStamp;
        // if (props.activeSectionObj).activeSectionObj
        // console.log('activeSectionObj', props.activeSectionObj)

        if (props.activeSectionObj) {
          setNarrativeUpdating(props.activeSectionObj.screenshot_timestamp);
          startTimeStamp = props.activeSectionObj.screenshot_timestamp;
          console.log('activeSectionObj.screenshot_timestamp',  props.activeSectionObj.screenshot_timestamp)
        } else {
          setNarrativeUpdating(props.narrative.modified);
          startTimeStamp = props.narrative.modified
          console.log('narrative.modified',  props.narrative.modified)
        }

        axios({
          method: 'POST',
          url:  Config.baseURL + "/api/cms/generate-narrative-pdf/",
          data: {id:  props.narrative.id},
          headers: {
            Authorization: 'Token ' + Cookies.get('_expo_tokenid')
          },
        })
        .then(response => {
            console.log('generate-narrative pdf', response);

            let url;
            if (props.activeSectionObj) {
              url = Config.baseURL + "/api/cms/section/" + props.activeSectionObj.id
            } else {
              url = Config.baseURL + "/api/cms/narrative-landing/" + props.narrative.id;
            }
            
            let interval = setInterval(() => {
              try {
                axios({
                    method: "get",
                    url: url,
                    headers: {
                      Authorization: 'Token ' + Cookies.get('_expo_tokenid')
                    },
                }).then((response) => {
                    const assetJSON = response.data;
                    let timeStamp;
                    if (props.activeSectionObj) {
                      timeStamp = assetJSON.screenshot_timestamp
                    } else {
                      timeStamp = assetJSON.modified;
                    }
                    

                    if (timeStamp > startTimeStamp) {
                      props.setPublishOn(false);
                      setNarrativeUpdating(false);
                      console.log('pdf ready', assetJSON.modified)
              
                      // Need to fix this so that it updates the thumbnails properly on the json fetch
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                      
                 
                      // props.fetchJSON();
                      // clearInterval(interval);
                    

                      
                    } else {
                      console.log('still generating pdf', assetJSON.modified)
                    }
                    
                    
                   
                   
                    
                });
            } catch (error) {
                console.error(error);
            }
            }, 10000);
      
            
            
        })
        .catch(error => {
            console.log('error', error.response);
        });
        }
      
    }

    function onZoomChoice(val) {
      console.log('onZoomChoice', val)
      setDropDown(null);
      switch (val) {
        case 'fit':
          try {
            let canvasForm = document.getElementById('canvasForm');
            let canvasFormWrap = document.getElementById('canvasFormWrap');
            let x_perc = canvasFormWrap.getBoundingClientRect().width/(canvasForm.getBoundingClientRect().width + 50);

            if (x_perc < 0.97 || x_perc > 1.03) {
              props.setZoomNumber(props.zoomNumber*x_perc);
              console.log('settings zoomNumber', props.zoomNumber*x_perc)
            }
          } catch (error) {
            console.log('resize error', error)
          }

          break;

        default:
          break;
      }
    }

    function closeUploadModal(){
      let modal = document.querySelector('#uploadModal');
      if (modal) modal.classList.remove('on');
    }

    function closeShapesModal(){
      setShowTools(false);
    }

    function onUploadBtn(){
      closeShapesModal();
      document.querySelector('#uploadModal').classList.toggle('on');
    }

    function onAddTemplate(){
      closeUploadModal();
      closeShapesModal();
      props.setShowTemplates(true);
    }
  

    return (
        <div id="narrativeTools">

          {props.showPages && <div className="iconField ui" onClick={() => { closeUploadModal(); closeShapesModal(); props.onNewPage(); }}><Icons.PageAdd className="icon ui" title="Add Page" onMouseEnter={(e) =>props.onMouseEnter(e, "Add Page")} onMouseLeave={() => props.onMouseLeave() } /></div>}

          {props.sectionId && <div className="iconField ui" onClick={() => onUploadBtn()} ><Icons.PhotoAdd className="icon ui" title="Add Layer" onMouseEnter={(e) =>props.onMouseEnter(e, "Add Layer")} onMouseLeave={() => props.onMouseLeave() } />
          
          <span className={'smModal'} id="uploadModal">
            <span className={'smModalChoice'} onClick={() => handleMediaChoice(true)}><UploadIcon className="icon" /> Upload File</span>
            <span className={'smModalChoice'} onClick={() => props.setShowAssetLibrary('add')}><AllPhotos className="icon" /> Select from Library</span>
          </span>
          
          </div>}
          
          {props.sectionId && <div className={"iconField ui" + ((activeBtn === 'text') ? " on": "")} onClick={() => addText()} ><Icons.Wysiwyg className="icon ui" title="wysiwyg editor" onMouseEnter={(e) =>props.onMouseEnter(e, "Add Text")} onMouseLeave={() => props.onMouseLeave() } /></div>}
        

          {props.sectionId && <input type="file" id="fileUpload" accept={acceptValues} onChange={() => handleLayerAdded('media', null)} multiple={false} />}

          {props.sectionId && <span className={classNames("ui iconField", props.isDrawing && "on")} onClick={() => { closeUploadModal(); setShowTools(prev => !prev); }}>

          {!props.isDrawing && <Icons.AddShapes className="icon ui" onMouseEnter={(e) =>props.onMouseEnter(e, "Add Shapes")} onMouseLeave={() => props.onMouseLeave() }  />}
          
          {props.isDrawing === 'rectangle' && <Icons.Rectangle className="icon ui" />}
          {props.isDrawing === 'ellipse' && <Icons.Circle className="icon ui" />}
          {props.isDrawing === 'star' && <Icons.Star className="icon ui" />}
          {props.isDrawing === 'line' && <Icons.Line className="icon ui" />}
          {props.isDrawing === 'arrow' && <Icons.Arrow className="icon ui" />}
          {props.isDrawing === 'arc' && <Icons.Arc className="icon ui" />}
          {props.isDrawing === 'drawing' && <Icons.Drawing className="icon ui" />}
          
          {showTools &&  <span className={'smModal on horizModal'} id="toolsModal">
          <span className={classNames('smModalChoice', props.isDrawing === 'rectangle' && 'active')} onClick={() => props.isDrawing !== 'rectangle' && props.setIsDrawing('rectangle')}><Icons.Rectangle className="icon" /></span>
          <span className={classNames('smModalChoice', props.isDrawing === 'ellipse' && 'active')} onClick={() => props.setIsDrawing('ellipse')}><Icons.Circle className="icon" /></span>
          <span className={classNames('smModalChoice', props.isDrawing === 'star' && 'active')} onClick={() => props.setIsDrawing('star')}><Icons.Star className="icon" /></span>
          <span className={classNames('smModalChoice', props.isDrawing === 'line' && 'active')} onClick={() => props.setIsDrawing('line')}><Icons.Line className="icon" /></span>
           <span className={classNames('smModalChoice', props.isDrawing === 'arrow' && 'active')} onClick={() => props.setIsDrawing('arrow')}><Icons.Arrow className="icon" /></span>
          <span style={{display: "none"}}  className={classNames('smModalChoice', props.isDrawing === 'arc' && 'active')} onClick={() => props.setIsDrawing('arc')}><Icons.Arc className="icon" /></span>
          <span className={classNames('smModalChoice', props.isDrawing === 'drawing' && 'active')} onClick={() => props.setIsDrawing('drawing')}><Icons.Drawing className="icon" /></span>
        </span>}



          </span>}

         {props.sectionId && <div className={"iconField ui" + ((activeBtn === 'popup') ? " on": "")} onClick={() => addPopup()} ><Icons.AddPopUp className="icon ui" title="add popup" onMouseEnter={(e) =>props.onMouseEnter(e, "Add Pop Up")} onMouseLeave={() => props.onMouseLeave() } /></div>}

        {props.sectionId && (props.narrative.template_id !== props.narrative.id)  && <div className="iconField ui" onClick={(e) => onAddTemplate(e)} ><Icons.AddTemplate className="icon ui" title="Add Layer" onMouseEnter={(e) =>props.onMouseEnter(e, "Add Template")} onMouseLeave={() => props.onMouseLeave() } /></div>}

     
          <h1>{props.narrative && props.narrative.title}</h1>

          {props.narrative && props.activeSectionObj && props.activeSectionObj.active && <a href={ Config.previewURL + "/narrative/" + props.narrative.id + "?u=" + props.user.link_token + "&slide=" + props.sectionId + "&nav=closed&action=page"} className="previewBtn noSubEvents" target="_blank" rel="noreferrer" title="preview" onMouseEnter={(e) =>props.onMouseEnter(e, "Preview")} 
          onMouseLeave={() => props.onMouseLeave() }>
          <OpenLink className="icon" /></a>}


          {props.sectionId && props.narrative.displays && props.activeDisplay && (
            <div className="displayBtns">
     
              <div id="settingsRow_displays"> 
                <div 
                  className="ui displayBtn" 
                  onClick={(e) => onDropDown(e, 'displays')}
                  onMouseEnter={(e) =>props.onMouseEnter(e, "Display")} 
                  onMouseLeave={() => props.onMouseLeave() }
                  >
                  <img src={Config.mediaURL + props.activeDisplay.icon_path} className="iconMd ui" alt="display icon" />
                  <ChevronDown className="down" />
                </div>
                <span className="inputField dropDownField"  id="inputField_displays_0">
                  <span className="dropDown">
                    <span className="dropDownChoices">

                {props.narrative.displays.map((o, i) => (
            
                  <span className="dropDownChoice ui" key={'displayDD_' + i}><div
                      onClick={(e) => onSelectDisplay(o) }
                      onMouseEnter={(e) =>props.onMouseEnter(e, o.name)} 
                      onMouseLeave={() => props.onMouseLeave() }
                      className={
                          "displayName noSubEvents" + (props.aspectRatio === 1 ? " on" : " off")
                      }
                  >
                  
                    <img src={Config.mediaURL + o.icon_path} className="icon ui" alt="display icon" />
                      <span>{o.name}</span>
                </div> </span>

                ))}

                </span>
                </span>
                </span>
              
              </div>  
            </div>
          )}

          <span className="zoomBtns">
            {props.activeSectionObj && <div className="zoom ui" onClick={() => handleZoom(50, 'in', props.canvasElem, props.activeDisplay, props.setZoomNumber, props.zoomNumber, props.setZoomRatio) }>+</div>}
            {props.activeSectionObj && <div className="zoom ui" onClick={() => handleZoom(-50, 'out',  props.canvasElem, props.activeDisplay, props.setZoomNumber, props.zoomNumber, props.setZoomRatio)}>–</div>}
          </span>

            <div className="zoomPresets">
     
              <div id="settingsRow_zoomPresets"> 
                <div 
                  className="ui displayBtn" 
                  onClick={(e) => onDropDown(e, 'zoomPresets')}
                  onMouseEnter={(e) =>props.onMouseEnter(e, "Zoom Presents")} 
                  onMouseLeave={() => props.onMouseLeave() }
                  >
                  {zoomState && zoomState + "%"}
                  <ChevronDown className="down" />
                </div>
                <span className="inputField dropDownField"  id="inputField_zoomPresets_0">
                  <span className="dropDown">
                    <span className="dropDownChoices">

                      <span className="dropDownChoice ui"><div
                      onClick={(e) => onZoomChoice('fit') }
                      className={
                          "zoomOption"
                        }
                       >
                  
                      <span>Fit Width</span>
                    </div> 
                
                    </span>
                </span>
                </span>
                </span>
              
              </div>  
            </div>
        


        </div>
    )
}

export default NarrativeTools;

// <div className={"iconField ui publishBtn" + (narrativeUpdating ? " rotate":"") + (props.publishOn ? " ready":"")}  onClick={() => updateNarrativePDF()} ><AutoRenew className="icon ui" title="Add Layer" /><div className="iconLabel">Publish</div></div>
// <div
// onClick={(e) => handleShowFullCanvas(e) }
// onMouseEnter={(e) =>props.onMouseEnter(e, "Remove frame")} 
// onMouseLeave={() => props.onMouseLeave() }
// className={
//       "displayName noSubEvents" + (props.showFullCanvas ? " on" : " off")
//   }
// >
// <Icons.CropFree className="icon ui" title="Remove Frame" />
// </div>